module.exports = __webpack_public_path__ + "img/icon-vot-viewcontestant.259a3758.png";